// This file defines the strapi endpoints you want to pull dtata from (collections & single types)
// This data will be fetched every time the page is loaded or refreshed

// slug = database table name, also known as API ID (Plural)
// fields = what columns from the table do you want to use?
// populate = how to show nested components & relations (doc: https://docs.strapi.io/developer-docs/latest/developer-resources/database-apis-reference/rest/populating-fields.html#relation-media-fields)
// There's two formats for doing this. Populate can be a string or qs.stringify()

import qs from "qs";

export const strapiPublicEndpoints = [
  // Single Types
  {
    slug: "about-us",
    fields: ["headerPhoto", "title", "richText", "logoImage", "staffHeading", "heading2", "richText2", "faqs", "FAQHeading", "locationHeading", "mapsURL"],
    populate: "populate=*",
  },

  {
    slug: "absence",
    fields: ["title", "name", "cadetRank", "date", "reason"],
    populate: "populate=*",
  },

  {
    slug: "contact-us",
    fields: ["title", "richText", "contactIcon"],
    populate: qs.stringify({
      populate: {
        contactIcon: {
          populate: "*",
        },
      },
    }),
  },

  {
    slug: "donate",
    fields: ["shop_items", "donateMessage"],
    populate: "populate=*",
  },

  {
    slug: "footer",
    fields: ["logo", "civiconnectURL", "cLogo", "socialMediaIcons", "attributions"],
    populate: qs.stringify({
      populate: {
        socialMediaIcons: {
          populate: "*",
        },
        logo: {
          populate: "*",
        },
        cLogo: {
          populate: "*",
        },
        attributions: {
          populate: "*",
        },
      },
    }),
  },

  {
    slug: "landing-page",
    fields: ["headerPhoto", "title", "heroBody", "newsletters", "landingButton", "heroBody2", "panels", "reviews", "eventsHeading", "publicCalendar"],
    populate: qs.stringify({
      populate: {
        panels: {
          populate: "*",
        },
        landingButton: {
          populate: "*",
        },
        headerPhoto: {
          populate: "*",
        },
      },
    }),
  },

  {
    slug: "navbar",
    fields: ["logo", "links", "linksHighlight"],
    populate: qs.stringify({
      populate: {
        logo: {
          populate: "populate=*",
        },
        links: {
          populate: {
            subLinks: {
              populate: "*",
            },
          },
        },
        linksHighlight: {
          populate: "*",
        },
      },
    }),
  },

  {
    slug: "resource-hub",
    fields: ["headerPhoto", "title", "body", "resources"],
    populate: "populate=*",
  },

  {
    slug: "sign-in",
    fields: ["image", "title", "signUpText"],
    populate: "populate=*",
  },

  {
    slug: "sign-up",
    fields: ["image", "title", "text", "roleChoice"],
    populate: "populate=*",
  },

  {
    slug: "user-profile",
    fields: ["resourceTiles", "trainingText", "trainingImage", "trainingImageAlt" ],
    populate: qs.stringify({
      populate: {
        resourceTiles: {
          populate: "*",
        },
        trainingImage: {
          populate: "*",
        },
      },
    }),
  },

  // Collections

  {
    slug: "faqs",
    fields: ["header", "body"],
    populate: "populate=*",
  },

  {
    slug: "newsletters",
    fields: ["title", "body", "photo", "featured", "date"],
    populate: "populate=*",
  },

  {
    slug: "pages",
    fields: ["slug", "title", "body", "coverImage"],
    populate: "populate=*",
  },

  {
    slug: "resources",
    fields: ["title", "pdf", "slug", "category"],
    populate: "populate=*",
  },

  {
    slug: "reviews",
    fields: ["name", "reviewText", "title"],
    populate: "populate=*",
  },

  {
    slug: "shop-items",
    fields: ["title", "price", "photo"],
    populate: "populate=*",
  },

  {
    slug: "staff-members",
    fields: ["headshot", "name", "title"],
    populate: "populate=*",
  },

  // {
  //   slug: "users",
  //   fields: ["username", "email", "name", "cadets","role"],
  //   populate: qs.stringify({
  //     populate: {
  //       cadets: {
  //         populate: "*",
  //       },
  //     },
  //   }),
  // },
];

export const strapiAuthenticatedEndpoints = [
  {
    slug: "calendars",
    fields: ["url", "role"],
    populate: "populate=*",
  },
  {
    slug: "training-links",
    fields: ["url", "role"],
    populate: "*",
  },
  {
    slug: "galleries",
    fields: ["title", "body", "photos", "role"],
    populate: qs.stringify({
      populate: {
        photos: {
          populate: "*",
        },
      },
    }),
  },
];
